const encodeCursor = (offset) => {
  return btoa(offset.toString().padStart(10, '@'));
};

export default encodeCursor;
